import { breakpoints } from 'hfs-common-ui';
import styled from 'styled-components';
import { mediaQuery } from '~/styled/GlobalStyles';

export const BackButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
  flex-shrink: 0;
  width: auto;
  ${mediaQuery.down.s`
    margin-left: -12px;
    button {
      line-height:1;
    }
  `}
  button {
    svg {
      path {
        fill: ${({ theme }) => theme.colors.onSurface};
      }
    }
  }
`;

export const TextWrapper = styled.div`
  color: var(--on-surface);
  cursor: pointer;
  &:hover {
    color: ${({ theme }) => theme.colors.grey500};
  }
  @media (max-width: ${breakpoints.s}px) {
    display: none;
  }
`;
